import { useEndImpersonate } from '@hooks/useEndImpersonate';
import { useV2OptOutParam } from '@hooks/useV2OptOutParam';
import { useAuth } from '@state/auth';
import { useEffect, useRef, useState } from 'react';

// Handles what the v2 app sends back: a deliberate return (`?optOut=1`, recorded
// so the launch prompt is not repeated) and impersonation cleanup
// (`?endImpersonate=1`).
//
// Nothing forwards to v2 from here any more. Each dashboard's login lands on
// that dashboard's own management area, and crossing over is a deliberate act
// via the navbar banner.
export default function FrontendV2Redirector({ children }) {
  useV2OptOutParam();

  const me = useAuth(state => state.me);
  const stopImpersonate = useAuth(state => state.stopImpersonate);
  const meReceived = useAuth(state => state.meReceived);

  const [endingImpersonate, setEndingImpersonate] = useState(
    () =>
      new URLSearchParams(window.location.search).get('endImpersonate') === '1',
  );
  const stoppingRef = useRef(false);
  const endImpersonateMutation = useEndImpersonate();

  useEffect(() => {
    if (!endingImpersonate || !me?.id || stoppingRef.current) return;
    stoppingRef.current = true;
    stopImpersonate();
    endImpersonateMutation
      .mutateAsync()
      .then(freshMe => {
        meReceived(freshMe);
      })
      .catch(() => {})
      .finally(() => {
        setEndingImpersonate(false);
        window.history.replaceState(null, '', window.location.pathname);
      });
  }, [me?.id, endingImpersonate]);

  return children;
}
